// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketingCopy--ilrPU {
  margin-bottom: 1rem;
}
.layout--uYa31 {
  display: grid;
  grid-template-columns: 260px repeat(12, 1fr);
  grid-template-rows: 1fr;
  width: 100%;
  min-height: 100vh;
  max-height: 100vh;
  grid-gap: 0.5rem;
}
.layout--uYa31 .left--BFgVP {
  grid-column: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: #F9FBFF;
  height: 100%;
  overflow: auto;
}
.layout--uYa31 .right--lBPGh {
  grid-column: 2 / -1;
  display: grid;
  grid-template-columns: 1fr minmax(0px, 48rem) 1fr;
  grid-template-rows: 1fr auto;
  grid-gap: 0.5rem;
  overflow: hidden;
}
@media (max-width: 768px) {
  .layout--uYa31 {
    display: flex;
    flex-direction: column;
  }
  .layout--uYa31 .left--BFgVP,
  .layout--uYa31 .right--lBPGh {
    grid-column: unset;
    width: 100%;
    overflow: auto;
  }
  .layout--uYa31 .left--BFgVP {
    order: 1;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    align-items: flex-start;
  }
  .layout--uYa31 .left--BFgVP.hasMessage--U0Fgt {
    min-height: 90px;
    max-height: 90px;
    height: 90px;
    overflow: hidden;
  }
  .right--lBPGh {
    flex: 1 1;
    order: 2;
    display: flex;
    flex-direction: column;
    justify-items: center;
    width: 100%;
  }
  .right--lBPGh > section {
    flex-grow: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/home/style.module.less"],"names":[],"mappings":"AAIA;EACE,mBAAA;AAHF;AAMA;EACE,aAAA;EACA,4CAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAJF;AAHA;EAUI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAbA;EAqBI,mBAAA;EACA,aAAA;EACA,iDAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AASA;EACE;IACE,aAAA;IACA,sBAAA;EAPF;EAKA;;IAMI,kBAAA;IACA,WAAA;IACA,cAAA;EAPJ;EADA;IAYI,QAAA;IACA,mBAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;EARJ;EAUI;IACE,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;EARN;EAaA;IACE,SAAA;IACA,QAAA;IACA,aAAA;IACA,sBAAA;IACA,qBAAA;IACA,WAAA;EAXF;EAKA;IASI,YAAA;EAXJ;AACF","sourcesContent":["@import \"~@boclips-ui/styles/src/colors\";\n\n@box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n\n.marketingCopy {\n  margin-bottom: 1rem;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: 260px repeat(12, 1fr);\n  grid-template-rows: 1fr;\n  width: 100%;\n  min-height: 100vh;\n  max-height: 100vh;\n  grid-gap: 0.5rem;\n\n  .left {\n    grid-column: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    background: @blue-100;\n    height: 100%;\n    overflow: auto;\n  }\n\n  .right {\n    grid-column: 2 / -1;\n    display: grid;\n    grid-template-columns: 1fr minmax(0px, 48rem) 1fr;\n    grid-template-rows: 1fr auto;\n    grid-gap: 0.5rem;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout {\n    display: flex;\n    flex-direction: column;\n\n    .left,\n    .right {\n      grid-column: unset;\n      width: 100%;\n      overflow: auto;\n    }\n\n    .left {\n      order: 1;\n      flex-direction: row;\n      flex-wrap: wrap;\n      display: flex;\n      align-items: flex-start;\n\n      &.hasMessage {\n        min-height: 90px;\n        max-height: 90px;\n        height: 90px;\n        overflow: hidden;\n      }\n    }\n  }\n\n  .right {\n    flex: 1 1;\n    order: 2;\n    display: flex;\n    flex-direction: column;\n    justify-items: center;\n    width: 100%;\n\n    > section {\n      flex-grow: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marketingCopy": `marketingCopy--ilrPU`,
	"layout": `layout--uYa31`,
	"left": `left--BFgVP`,
	"right": `right--lBPGh`,
	"hasMessage": `hasMessage--U0Fgt`
};
export default ___CSS_LOADER_EXPORT___;
